// extracted by mini-css-extract-plugin
export default {"brandPromo":"OE-z","carousel":"PE-z"};